import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocReportsTeamRedirectRoute: InvariantJiraRoute = {
	name: 'eoc-reports',
	path: '/jira/ops/teams/:teamId/reports',
	exact: true,
};
